var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7029 5.54907L10.1541 8.35811C9.48246 8.87576 8.54099 8.87576 7.86938 8.35811L4.29004 5.54907",
    stroke: "#FC2B6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.06674 1.00024H12.9108C14.0418 1.01272 15.1183 1.48277 15.8896 2.30094C16.6608 3.11911 17.0595 4.21397 16.9928 5.33053V10.67C17.0595 11.7865 16.6608 12.8814 15.8896 13.6995C15.1183 14.5177 14.0418 14.9878 12.9108 15.0002H5.06674C2.63736 15.0002 1 13.0573 1 10.67V5.33053C1 2.94322 2.63736 1.00024 5.06674 1.00024Z",
    stroke: "#FC2B6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/MessageIcon.a34e28c011dce682f3902d952569f330.svg";
export { ForwardRef as ReactComponent };